/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidacyProfileEntryDestroyPathParams,
	CandidacyProfileEntryDestroyResponse,
} from '../types/CandidacyProfileEntryDestroy'

/**
 * DELETE /candidate-center/organisations/:organisation/candidacies/:candidacy/profile/:section/:entry
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyProfileEntryController.php CandidacyProfileEntryController::destroy
 */
export async function candidacyProfileEntryDestroy(
	organisation: CandidacyProfileEntryDestroyPathParams['organisation'],
	candidacy: CandidacyProfileEntryDestroyPathParams['candidacy'],
	section: CandidacyProfileEntryDestroyPathParams['section'],
	entry: CandidacyProfileEntryDestroyPathParams['entry'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidacyProfileEntryDestroyResponse>> {
	return axiosInstance.delete(
		`/candidate-center/organisations/${organisation}/candidacies/${candidacy}/profile/${section}/${entry}`,
		config,
	)
}
